import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { checkCsv, submitUserConfirmation, handleFailedSubmit } from '../../../actions/website/FileUploadActions';
import { hideModal } from '../../../actions/ModalActions';
import FileInputButton from '../../common/form/FileInputButton';

class CheckGuestDuplicatesModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      busy: this.props.busy,
      error: undefined,
      fileInputKey: 1,
    };
    this.onCloseModal = this.onCloseModal.bind(this);
    this.processError = this.processError.bind(this);
  }

  onCloseModal() {
    const { closeModal } = this.props;
    closeModal();
  }

  finalUserSubmit() {
    const { handleUpload } = this.props;
    return handleUpload().catch(error => error.response.json().then(this.processError).then(this.handleError));
  }

  // todo: move processError out into a utility funciton its gross and repetitive
  checkCsvFormat(file, guestsInGuestList) {
    const { onFileCheck } = this.props;
    this.setState({
      error: undefined
    });
    return onFileCheck(file, guestsInGuestList).catch(error => error.response.json().then(this.processError));
  }

  processError(error) {
    let errorMessage;
    if (error.category && error.category.domain === 'bulk-import') {
      switch (error.category.reason) {
        case 'unknown-column':
          errorMessage = `Your file contains an unknown column. Please remove ${error.trigger}, and try again. Use the Zola provided .csv spreadsheet column names.`;
          break;
        case 'missing-column':
          errorMessage = `Your file contains a missing column. Please add ${error.trigger}, and try again. Use the Zola provided .csv spreadsheet column names.`;
          break;
        case 'primary-name-missing':
          errorMessage = `You are missing a First Name or Last Name in row ${_.toInteger(error.trigger) + 1}. Please add the guest’s name, and try again.`;
          break;
        case 'illegal-characters':
          errorMessage = `Row ${_.toInteger(error.trigger) + 1} contains "[];<>{}\\". Please remove, and try again.`;
          break;
        case 'row-length':
          errorMessage = `Row ${_.toInteger(error.trigger) + 1} contains too many columns. Please use the Zola provided .csv spreadsheet columns and do not add text beyond those columns.`;
          break;
        case 'wrong-file-type':
          errorMessage = 'Please use the Zola provided .csv spreadsheet to import your guest list.  Make sure to save your file as a .csv.';
          break;
        case 'extra-column':
          errorMessage = 'Your file contains a blank column. Please use the Zola provided .csv spreadsheet columns and do not add text beyond those columns.';
          break;
        case 'parsing-failed':
        default:
          errorMessage = 'There was an error uploading your file. Please use the Zola provided .csv spreadsheet column names and try again.';
      }
    } else {
      errorMessage = 'There was an error uploading your file. Please use the Zola provided .csv spreadsheet column names and try again.';
    }

    this.setState({
      error: errorMessage,
      fileInputKey: this.state.fileInputKey + 1
    });
  }

  render() {
    const { busy, guestsInGuestList } = this.props;
    const { error, fileInputKey } = this.state;
    return (
      <div id="check-guest-duplicates">
        <div className="duplicate-modal-container">
          <div className="modal-content">
            <h3>Oops! You may have duplicate guests.</h3>
            <p>Looks like you&apos;re uploading a spreadsheet that may contain guests already in Guest List. To avoid duplicates, please delete any names from your spreadsheet that you&apos;ve already added.</p>
            {!error ? (
              <div className="text-center duplicate-modal-actions">
                <div className="btn btn-secondary btn-left" onClick={() => this.onCloseModal()}>Cancel</div>
                <div className={['btn btn-primary btn-right ', busy ? 'disabled-submit' : null].join(' ')} onClick={() => this.finalUserSubmit()}>Continue With Upload</div>
              </div>
            ) : (
              <div className="error-instance-container">
                <p className="text-danger margin-bottom-2x">{error}</p>
                <div className="text-center duplicate-error-actions">
                  <div className="btn btn-secondary btn-left cancel-btn" onClick={() => this.onCloseModal()}>Cancel</div>
                  <FileInputButton
                    key={fileInputKey}
                    btnClass="btn-primary btn-right"
                    inputId="csv_upload"
                    types="text/csv"
                    onSelect={file => this.checkCsvFormat(file, guestsInGuestList)}
                    btnText="Try Again"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    );
  }
}

CheckGuestDuplicatesModal.propTypes = {
  onFileCheck: PropTypes.func,
  closeModal: PropTypes.func,
  handleUpload: PropTypes.func,
  busy: PropTypes.bool,
  guestsInGuestList: PropTypes.arrayOf(
    PropTypes.number
  ),
};

const mapStateToProps = state => ({
  account: state.wedding.account,
  busy: state.modal.busy,
  guestsInGuestList: state.guestList.guests.orderedIds,
});

const mapDispatchToProps = dispatch => ({
  onFileCheck: (file, guestsInGuestList) => dispatch(checkCsv(file, guestsInGuestList)),
  handleUpload: () => dispatch(submitUserConfirmation()),
  closeModal: () => dispatch(hideModal()),
  handleErrorState: referenceKey => dispatch(handleFailedSubmit(referenceKey))
});


export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CheckGuestDuplicatesModal);




// WEBPACK FOOTER //
// ./src/components/manage/guestlist/CheckGuestDuplicatesModal.jsx